import {
  IconNameEnum,
  useActivitiesStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreActivitiesComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { ReviewSummary } from "@b2bportal/rbc-activities-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon, TripadvisorRatingIcon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./TripAdvisorRating.module.scss";

export type TripAdvisorRatingProps = PlatformComponentProps & {
  rating: ReviewSummary;
};

export const TripAdvisorRating = ({
  rating,
  className,
}: TripAdvisorRatingProps) => {
  const styles = useActivitiesStyles(
    CoreActivitiesComponent.TripAdvisorRating,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreActivitiesComponent.TripAdvisorRating
  );

  const { t } = useI18nContext();

  if (!rating?.reviewAverage || !rating?.numberOfReviews) {
    return null;
  }

  const normalizedRating = Math.round(rating.reviewAverage * 2) / 2;

  return (
    <div className={clsx(block, className)}>
      <Icon
        useCurrentColor={false}
        className={cn("tripadvisor-icon")}
        iconName={IconNameEnum.tripadvisor}
      />
      <TripadvisorRatingIcon scoreOutOfFive={normalizedRating} />
      <div className={cn("tripadvisor-rating")}>{rating.reviewAverage}</div>
      <div className={cn("tripadvisor-review-count")}>
        (
        {t("core-activities.shopPage.customerReviews.reviewCount", {
          count: rating.numberOfReviews,
        })}
        )
      </div>
    </div>
  );
};
